export default {
  TITLE: 'Cookies 政策',
  CONTENT: `
    <h3>最近更新： 2020年10月1日</h3>
    <p>
      我们使用 cookies 、像素及其他技术（合称 "cookies"）识别您的浏览器或设备，了解您的利益，并为您提供基本功能和服务及其他用途，包括：
    </p>
    <ul class="number-format">
      <li>
        当您登录并使用我们的服务时用于识别您。这允许我们为您提供产品推荐、显示个性化内容、将您识别为Prime 会员、使您能够使用一键购买，以及提供其他定制功能和服务。
      </li>
      <li>
        持续追踪您指定的偏好。这允许我们尊重您的偏好，例如您是否希望看到兴趣导向的广告。您可以通过<a data-path="adPreference">我的账户</a> 设置您的偏好。
      </li>
      <li>持续追踪存储在您购物车中的物品。</li>
      <li>进行研究和诊断，以改善亚马逊的内容、产品和服务。</li>
      <li>防止欺诈行为。</li>
      <li>提高安全性。</li>
      <li>
        在亚马逊网站和第三方网站上传递与您的兴趣相关的内容，包括广告（关于我们如何使用cookies 投放兴趣导向的广告，请参见<a data-path="adPreference">兴趣导向广告的通知</a> ）。
      </li>
      <li>报告。这允许我们衡量和分析我们的服务的性能。</li>
    </ul>
    <p>
      亚马逊的 cookies可以让您充分利用亚马逊的一些基本功能。例如，如果您阻止或以其他方式拒绝我们的 cookies，您将无法添加商品至您的购物车、继续结账、或使用任何需要您登录的亚马逊产品和服务。
    </p>
    <p>
      当您与亚马逊服务互动时，授权的第三方也可以设置 cookies。第三方包括搜索引擎、衡量和分析服务的提供商、社交媒体网络、和广告公司等。第三方在传递内容的过程中使用 cookies
      ，包括与您的兴趣相关的广告，以衡量其广告的有效性，并代表亚马逊提供服务。
    </p>
    <p>
      您可以通过浏览器设置来管理浏览器 cookies 。大多数浏览器上的 " 帮助 "功能将告诉您如何阻止浏览器接受新 cookies 、如何让浏览器在收到一个新cookie 时通知您、如何阻止 cookies 、以及 cookies
      何时过期。如果您阻止浏览器上的所有 cookies ，我们或第三方都不会将 cookies传输到您的浏览器。但是，如果您这样做，您可能在每次访问一个网站时都必须手动调整一些偏好，并且有些功能和服务可能无法工作。
    </p>
    <p>
      有关我们收集的信息类型的更多信息，请参阅我们的<a data-path="termStatement" data-title="PRIVACY_STATEMENT">隐私声明</a>。
    </p>
  `
};
